module.exports = __webpack_public_path__ + "static/media/gp8.cf8a2869.webp";